import React, { useEffect, useState } from "react";
import {
  getSparesstocklist,
  addRack,
  removeRack,
  updateStock,
} from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";

const ViewSparesStockUpdate = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchProducts(page, pageSize);
  }, [page, pageSize]);

  const fetchProducts = async (page, pageSize) => {
    setLoading(true);
    try {
      const data = await getSparesstocklist(page, pageSize);
      setProducts(data.slice((page - 1) * pageSize, page * pageSize));
      setTotalItems(data.length);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (productId, field, value) => {
    const updated = products.map((item) =>
      item.productid === productId
        ? { ...item, [field]: value }
        : item
    );

    setProducts(updated);
  };

 const handleSubmit = async (product) => {
  if (!product.rackPosition || !product.quantity) {
    showSnackbar("error", "Please enter rack and quantity before submitting!");
    return;
  }

  try {
    const response = await updateStock(
      product.productid,
      product.rackPosition,
      Number(product.quantity)
    );

    showSnackbar("success", response);

    // OPTIONAL: clear only that row instead of full reload
    setProducts((prev) =>
      prev.map((item) =>
        item.productid === product.productid
          ? { ...item, rackPosition: "", quantity: "" }
          : item
      )
    );

    // OR keep your existing:
    // fetchProducts(page, pageSize);

  } catch (err) {
    console.error(err);
    showSnackbar("error", "Failed to update stock");
  }
};
  const handleAddRack = async (product, index) => {
    if (!product.rackPosition) {
      showSnackbar("error", "Please enter a rack position before adding!");
      return;
    }

    try {
      const response = await addRack(product.productid, product.rackPosition);

      showSnackbar("success", response);
      fetchProducts(page, pageSize);

      const updated = [...products];
      updated[index].disabled = true;
      setProducts(updated);
    } catch (err) {
      console.error(err);
      showSnackbar("error", "Failed to add rack");
    }
  };

  const handleRemove = async (product, index) => {
    if (!product.rackPosition) {
      showSnackbar("error", "Please enter a rack position to remove!");
      return;
    }

    try {
      const response = await removeRack(product.productid, product.rackPosition);

      showSnackbar("success", response);
      fetchProducts(page, pageSize);
    } catch (err) {
      console.error(err);
      showSnackbar("error", "Failed to remove rack");
    }
  };


  const totalPages = Math.ceil(totalItems / pageSize);

  // Filter products based on search text
  // Filter products based on search text (productid, subcategory, modelno)
 const filteredProducts = products.filter((p) => {
  const search = searchText.trim().toLowerCase();
  if (!search) return true;

  return (
    p.productid.toString().includes(search) ||
    p.subcategory?.toLowerCase().includes(search) ||
    p.modelno?.toLowerCase().includes(search)
  );
});

  if (loading) return <p>Loading...</p>;

  return (
         <div
    style={{
      width: "80vw",
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      position: "relative",
    }}
  >
    <div className="stock-tools-container">
      <input
        type="text"
        placeholder="Search "
        className="search-input"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />


      <table className="stock-table">
        <thead>
          <tr>
            <th>ProductId</th>
            <th>SubCategory</th>
            <th>Model No</th>
            <th>Stock QTY</th>
            <th>Rack</th>
            <th>RackPosition</th>
            <th>Quantity</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((p, i) => (
            <tr key={p.productid}>
              <td>{p.productid}</td>
              <td>{p.subcategory}</td>
              <td>{p.modelno}</td>
              <td>{p.stock ?? 0}</td>
              <td>{p.rack || ""}</td>
              <td>
                <input
                  type="text"
                  value={p.rackPosition || ""}
                  onChange={(e) =>
                    handleChange(p.productid, "rackPosition", e.target.value)
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  value={p.quantity || ""}
                  onChange={(e) =>
                    handleChange(p.productid, "quantity", e.target.value)
                  }
                />
              </td>
              <td className="action-buttons">
                <button
                  className="submit-btn1"
                  onClick={() => handleSubmit(p)}
                  disabled={!p.rackPosition || !p.quantity || p.disabled}
                >
                  Submit
                </button>
                <button
                  className="add-rack-btn"
                  onClick={() => handleAddRack(p, i)}
                  disabled={!p.rackPosition || !p.quantity || p.disabled}
                >
                  Add Rack
                </button>
                <button
                  className="remove-btn"
                  onClick={() => handleRemove(p, i)}
                  disabled={!p.rackPosition || !p.quantity || p.disabled}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}

      <div className="pagination-container">

        <div style={{ color: "black" }}>

          Items per page:

          <select
            className="page-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >

            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}

          </select>

        </div>



        <div className="page-buttons">

          <button
            className="page-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>


          <span className="page-count">

            {page} / {totalPages || 1}

          </span>


          <button
            className="page-btn"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>

        </div>


      </div>

      {/* Styles */}
      <style>{`
          .stock-tools-container {
            padding: 20px;
            font-family: Arial, sans-serif;
          }

          .search-input {
            margin-bottom: 15px;
            padding: 6px 10px;
            width: 200px;
            border: 1px solid #ccc;
            border-radius: 4px;
          }

          .stock-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 15px;
          }

          .stock-table th,
          .stock-table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: center;
          }

          .stock-table th {
            background-color: #f5f5f5;
          }

          .rack-input,
          .qty-input {
            width: 90%;
            padding: 4px 6px;
            border: 1px solid #ccc;
            border-radius: 4px;
          }

          .action-buttons {
            display: flex;
            justify-content: center;
            gap: 5px;
            flex-wrap: nowrap;
          }

          .action-buttons button {
            padding: 5px 10px;
            border: none;
            border-radius: 4px;
            color: #fff;
            cursor: pointer;
            font-size: 12px;
            
          }

          .submit-btn1 { background-color: #4CAF50; height :30px} /* green */
          .add-rack-btn { background-color: #2196F3; } /* blue */
          .remove-btn { background-color: #f44336; } /* red */
          
          .pagination {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            font-size: 14px;
          }

          .pagination select {
            margin-left: 5px;
            padding: 3px 6px;
          }

          .page-controls button {
            padding: 4px 8px;
            margin: 0 3px;
            border: 1px solid #ccc;
            border-radius: 4px;
            cursor: pointer;
          }

          .page-controls button:disabled {
            cursor: not-allowed;
            opacity: 0.5;
          }
            
.pagination-container{
display:flex;
justify-content:space-between;
align-items:center;
margin-top:20px;
padding:10px;
border-top:1px solid #eee;
}


.page-select{

padding:6px 10px;
border:1px solid #ccc;
border-radius:5px;
margin-left:5px;
cursor:pointer;

}


.page-buttons{

display:flex;
align-items:center;
gap:10px;

}


.page-btn{

padding:6px 14px;
border:none;
border-radius:5px;
background:#3498db;
color:white;
cursor:pointer;
font-size:13px;
transition:0.2s;

}

.page-btn:hover{

background:#2980b9;

}


.page-btn:disabled{

background:#ccc;
cursor:not-allowed;

}


.page-count{

font-weight:bold;

}
        `}</style>
    </div>
    </div>
  );
};

export default ViewSparesStockUpdate;
